export interface ToastMsg {
  kind: 'success' | 'error';
  msg: string;
}

/** Shared bottom-center toast (W-C): one styled surface for mutation feedback
 * so failures never render as silence. Pages own the state; this renders it. */
export default function Toast({
  toast,
  onDismiss,
}: {
  toast: ToastMsg | null;
  onDismiss?: () => void;
}) {
  if (!toast) return null;
  return (
    <div
      role="status"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-rise"
      data-testid={`toast-${toast.kind}`}
    >
      <div
        className={`ff-card flex items-center gap-3 px-4 py-2.5 border ${
          toast.kind === 'success'
            ? 'border-ff-success/25 bg-ff-success-soft'
            : 'border-ff-danger/30 bg-ff-danger-soft'
        }`}
      >
        <span
          className={`h-2 w-2 rounded-full ${
            toast.kind === 'success' ? 'bg-ff-success' : 'bg-ff-danger'
          }`}
        />
        <span className="text-sm">{toast.msg}</span>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="text-xs font-mono uppercase text-ff-mute hover:text-ff-forest"
            aria-label="Dismiss notification"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
